import React from 'react';

/**
 * 引数配列からセレクトボックスのオプション要素を生成する関数
 *
 * @param {Array<string>} options - オプションの値の配列
 * @param {function} formatMessage - i18nメッセージを文字列に変換する関数
 * @param {string} prefix - i18nメッセージのIDのプレフィックス。
 * @returns {Array<JSX.Element>} JSXオプション要素の配列。
 */
const createSelectOptions = (options, formatMessage, messageIdPrefix) =>
  options.map(optionValue => {
    const text = formatMessage({ id: `${messageIdPrefix}.${optionValue}` });
    return (
      <option value={optionValue} key={`status_${optionValue}`}>
        {text}
      </option>
    );
  });

export default createSelectOptions;
